import { withDob } from '../../../utils/date';
import { LeadDetailsResponse } from '../types';

const getLeadName = (lead?: LeadDetailsResponse) => {
    const { first_name, last_name, date_of_birth } = lead?.primary_user_details ?? {};

    return first_name && last_name ? withDob(`${first_name} ${last_name}`, date_of_birth) : '-';
};

export default getLeadName;
